const getUserID = state => state.auth.id;

export default { getUserID };